<template>
  <div
    class="projectChange"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <template v-if="detailList">
      <div v-for="(item, index) in detailList" :key="index">
        <BasicInfo :fromData="item" :title="moduleTitle(index)"></BasicInfo>
      </div>
    </template>
    <template v-else>
      <div style="text-align: center; background-color: white; padding: 50px">
        暂无历史变更数据
      </div>
    </template>
  </div>
</template>
<script>
  import BasicInfo from './components/basicInfo.vue';
  import wumaoProjectApi from '@/api/purchaseSalesCenter/wumaoProject.js';
  export default {
    name: 'projectChange',
    data() {
      return {
        isLoading: false,
        detailList: [],
        fromData: {
          projectInitiationNo: '',
          projectInitiationCreateDate: '',
          businessType: '',
          businessTypeName: '',
          projectName: '',
          projectAddress: '',
          indication: '',
          platformtCompany: [],
          platformtCompanyName: [],
          applyDepartmentNo: '',
          applyDepartmentName: '',
          subjectMatter: '',
          subjectMatterName: '',
          supplierNo: [],
          supplierName: [],
          customerNo: [],
          customerName: [],
          chargePersonNo: '',
          chargePersonName: '',
          declareDate: '',
          projectAccountingPeriod: '',
          projectUsageQuotaWan: '',
          projectReceivableQuotaWan: '',
          expenseBudget: '',
          projectIncomePoint: '',
          operatingRevenueTarget: '',
          profitTarget: '',
          projectNetProfitRate: '',
          grossProfitRate: '',
          deliveryQuantity: '',
          advanceAmount: '',
          // stampDuty: '',
          // travelExpense: '',
          // taxRate: '',
          costPrediction: '',
          costOfFunds: '',
          taxCost: '',
          sellingExpenses: '',
          projectMonthlyReturnRate: '',
          effectiveDateOfYield: '',
          upstreamSettlementAdjustment: '',
          upstreamSettlementAdjustmentValue: '',
          serviceChainRestriction: '',
          paymentMethod: '',
          paymentMethodName: '',
          remark: '',
          approveDate: '',
        },
      };
    },
    mounted() {
      this.queryHistory();
      // this._getCompanyApi1();
    },
    methods: {
      async queryHistory() {
        this.isLoading = true;
        const { data } = await this.$axios.post(wumaoProjectApi.QUERY_HISTORY, {
          // projectInitiationNo: 'LX0000103',
          projectInitiationNo: this.$route.query.projectInitiationNo,
        });
        this.isLoading = false;
        if (data.code == 0) {
          this.detailList = data.data;
          // await this._getDepartment(platformtCompany.split(','));
        } else {
          this.$message.error('获取详情失败');
        }
      },
      moduleTitle(index) {
        if (index == 0) {
          return '最新数据';
        } else if (index == this.detailList.length - 1) {
          return '原始数据';
        } else {
          return `变更数据${this.detailList.length - 1 - index}`;
        }
      },
    },
    components: {
      BasicInfo,
    },
  };
</script>
